import { render, staticRenderFns } from "./ExcludedIcon.vue?vue&type=template&id=cfd7c4aa&scoped=true"
import script from "./ExcludedIcon.vue?vue&type=script&lang=js"
export * from "./ExcludedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd7c4aa",
  null
  
)

export default component.exports